import { ShowHide } from '@/components/showHide';
import DataGrid from '@/components/dataGrid/dataGrid';
import Header from '@/core/components/header/header';
import ButtonGoToUpload from '@/modules/cadastralDataMatching/components/buttonGoToUpload/buttonGoToUpload';
import {
  CADASTRAL_DATA_MATCHING_STATUS, CADASTRAL_DATA_MATCHING_STATUS_COLOR,
  CADASTRAL_DATA_MATCHING_STATUS_TRANSLATED, CadastralDataMatchingParamsToFilter,
} from '@/modules/cadastralDataMatching/entities';
import { COMPANY_CONFIG_NAME, COMPANY_CONFIG_VALUE } from '@/modules/company/entities/enums/company';
import { MoveResponse } from '@/modules/move/entities/interfaces/move';
import useCompany from '@/shared/hooks/useCompany/useCompany';
import { MonitoringService } from '@/shared/modules/monitoring/services/monitoringService';
import ICONS from '@/shared/entities/constants/icons';
import React, { useMemo } from 'react';
import { Chip, Text } from 'vkit/lib/components';

const List: React.FC = () => {
  const { getFirstCompanyConfigByKey } = useCompany();
  const layoutType = getFirstCompanyConfigByKey(COMPANY_CONFIG_NAME.CADASTRAL_DATA_MATCHING_LAYOUT);
  const statusSelectOptions = useMemo(
    () =>
      Object.values(CADASTRAL_DATA_MATCHING_STATUS).map((statusKey) => ({
        text: CADASTRAL_DATA_MATCHING_STATUS_TRANSLATED[statusKey],
        value: statusKey,
      })),
    [],
  );

  return (
    <>
      <Header iconSrc={ICONS.CADASTRAL_DATA_MATCHING} title={'Bate Cadastral'}>
        <ButtonGoToUpload />
      </Header>

      <ShowHide visible={!layoutType} transition='slideToDown'>
        <Text
          rounded
          size='medium'
          applyBaseColor
          color='warning'
          iconColor='warning'
          padding='8px 12px'
          icon={ICONS.WARNING}
          value='Esta empresa não possui as configurações necessárias para visualização da lista de bates cadastrais.'
        />
      </ShowHide>

      <DataGrid
        source={(filters, companyId) =>
          new MonitoringService().getFiles<MoveResponse, CadastralDataMatchingParamsToFilter>({
            ...filters,
            companyId,
            type: [COMPANY_CONFIG_VALUE.CADASTRAL_DATA_MATCHING_ALL_LAYOUTS],
            sort: '-uploadedAt',
          })
        }
        columns={[
          {
            headerName: 'Nome do arquivo',
            field: 'name',
          },
          {
            headerName: 'Status',
            render: ({ status }) => (
              <Chip
                rounded
                size='small'
                label={CADASTRAL_DATA_MATCHING_STATUS_TRANSLATED[status]}
                color={CADASTRAL_DATA_MATCHING_STATUS_COLOR[status]}
              />
            ),
          },
          {
            headerName: 'Data da criação',
            field: 'createdAt',
            formatData: 'dateTime',
          },
        ]}
        filters={[
          {
            label: 'Buscar',
            key: 'q',
          },
          {
            label: 'Status',
            type: 'select',
            data: statusSelectOptions,
            key: 'status',
          },
          {
            label: 'Data de criação',
            type: 'date',
            key: 'createdAtMin',
          },
        ]}
        actionsByItem={[
          {
            redirectToDetail: ({ id }, companyId) =>
              `/companies/${companyId}/cadastral-data-matchings/${id}/details`,
          },
        ]}
      />
    </>
  );
};

export default List;
